const CAMEL_CASE_MATCH = /([A-Z])/g;

/**
 * Converts a camelCase string to an underscore_string
 */
export const camelToSnake = (key: string): string =>
    key.replace(CAMEL_CASE_MATCH, (chars) => `_${chars.toLowerCase()}`);
